<template>
    <div>          
        <h4 class="p-2">Becas aplicadas</h4>
            <vs-row class="mt-4">
                <vs-col sm="12" lg="4">
                    <form autocomplete="off">
                        <label for="institucion" class="labelInput">
                            Institución
                        </label>
                        <vs-select filter class="aqui pt-0" id="institucion" placeholder="Seleccionar Institución" :key="institucionId" v-model="institucion" v-if="instituciones.length" :disabled="!instituciones.length" @input="getCicloEscolar()" >
                            <template #message-danger v-if="errorFields.includes('institucion')">
                                Requerido
                            </template>
                            <template v-if="instituciones.length">
                                <vs-option v-for="option in instituciones" :key="option.id"  :label="option.text" :value="option.id">
                                    {{option.text}}
                                </vs-option>
                            </template>
                            <template v-else>
                                <vs-option label="No hay datos" :value="0">
                                    No hay datos
                                </vs-option>
                            </template>
                        </vs-select>
                    </form>
                </vs-col>
                <vs-col sm="12" lg="4">
                    <form autocomplete="off">
                        <label for="cicloEscolar" class="labelInput">
                            Ciclo Escolar
                        </label>
                        <vs-select filter :loading="loadingCicloEscolar" class="aqui pt-0" id="cicloEscolar" placeholder="Seleccionar Ciclo Escolar" :key="cicloId" v-model="cicloEscolar" v-if="instituciones.length" :disabled="!ciclosEscolares.length" >
                            <template #message-danger v-if="errorFields.includes('cicloEscolar')">
                                Requerido
                            </template>
                            <vs-option v-for="option in ciclosEscolares" :key="option.id"  :label="option.text" :value="option.id">
                                {{option.text}}
                            </vs-option>
                        </vs-select>
                    </form>
                </vs-col>
                <vs-col sm="12" lg="4">
                    <div class="d-flex " style="justify-content: space-between;">
                        <label for="grupo" class="labelInput">
                            Grupo
                        </label>
                        <div class="d-flex" v-if="grupos[0]">
                            <div> 
                                <vs-tooltip>
                                    <i class="fas fa-check-square" style="cursor:pointer" @click="selectAll(grupos, 'grupos')"></i>
                                    <template #tooltip>
                                        Seleccionar todo
                                    </template>
                                </vs-tooltip>
                            </div>
                            <div class="labelInput">
                                <vs-tooltip>
                                    <i class="far fa-times-circle" style="cursor:pointer" @click="deseleccionarAll('grupos')"></i>
                                    <template #tooltip>
                                        Deseleccionar todo
                                    </template>
                                </vs-tooltip>
                            </div>
                            
                        </div>
                    </div>
                    <div style="position: relative">
                        <vs-select filter multiple collapse-chips :loading="loadingGrupo" class="aqui pt-0" id="grupo" placeholder="Seleccionar Grupo" :key="gruposId" v-model="grupo" :disabled="!grupos.length" autocomplete="off">
                            <template #message-danger v-if="errorFields.includes('grupo')">
                                Requerido
                            </template>
                            <vs-option v-for="option in grupos" :key="option.id"  :label="option.text" :value="option.id">
                                {{option.text}}
                            </vs-option>
                        </vs-select>
                    </div>
                </vs-col>
                <vs-col sm="12" lg="4">
                    <form autocomplete="off">
                        <label class="labelInput">
                            Estatus
                        </label>
                        <vs-select filter class="pt-0" placeholder="Estatus" v-model="estatus">
                            <vs-option label="Becas aplicada" value="activo">
                                Becas aplicada
                            </vs-option>
                            <vs-option label="Becas desaplicada" value="desaplicada">
                                Becas desaplicada
                            </vs-option>
                            <template #message-danger v-if="errorFields.includes('estatus')">
                                Requerido
                            </template>
                        </vs-select>
                    </form>
                </vs-col>
                <vs-col w="12">
                    <vs-button
                        class="ml-auto"
                        @click="getBecasAplicadas()"
                    >
                        <i class="fas fa-search mr-2"></i>Buscar
                    </vs-button>
                </vs-col>
            </vs-row>
            <estadisticas :users="estadisticas_becas"></estadisticas>
            <vs-row v-if="users.length">
                <vs-col sm="12" lg="3" class="ml-auto">
                    <vs-button
                        class="ml-auto"
                        success
                        :loading="loadingExcel"
                        @click="getFileBecasAplicas()"
                    >
                        Descargar archivo
                    </vs-button>
                </vs-col>
            </vs-row>
            <tabla-becas-aplicadas :users="users" :institucion="institucion" :estatus="estatusFiltro" :cicloEscolar="cicloEscolar"></tabla-becas-aplicadas>
    </div>
</template>

<script>
import reportes from '../../../../api/requests/reportes.js'
import TablaBecasAplicadas from './tabla-becas-aplicadas.vue'
import estadisticas from './estadisticas.vue'
export default {
    data(){
        return{
            active: 0,
            institucion: '',
            instituciones: [],
            institucionId: (new Date()).getTime(),
            cicloEscolar: '',
            ciclosEscolares: [],
            cicloId: (new Date()).getTime(),
            loadingCicloEscolar: false,
            grupo: '',
            grupos: [],
            gruposId: (new Date()).getTime(),
            loadingGrupo: false,
            codigoDetalle: '',
            codigosDetalle: [],
            codigosDetalleId: (new Date()).getTime(),
            loadingCodigo: false,
            estatus: '',
            users: [],
            estadisticas_becas: {},
            errorFields: [],
            estatusFiltro: '',
            loadingExcel: false
        }
    },
    components:{
        TablaBecasAplicadas,
        estadisticas
    },
    created(){
        this.getInstituciones()
    },
    methods: {
        selectAll(seleccion, tipo){
              let arr = []
            seleccion.forEach(i => {
              arr.push(i.id)
            })
            if(tipo == 'grupos'){
                this.grupo = arr
            }
            if(tipo == 'codigo'){
                this.codigoDetalle = arr
            }
        },
        deseleccionarAll(tipo){
            if(tipo == 'grupos'){
                this.grupo = ''
            }
            if(tipo == 'codigo'){
                this.codigoDetalle = ''
            }
        },
        async getInstituciones(){
            try {
                const response = await reportes.getInstitucion()
                this.instituciones = response.data
            }
            catch{
                
            }
        },
        async getCicloEscolar() {
            if(this.institucion){
                this.cicloEscolar = ''
                try {
                    this.loadingCicloEscolar = true
                    const { data: response } = await reportes.getCiclosEscolares(this.institucion)
                    this.ciclosEscolares = response
                    this.cicloId = (new Date()).getTime()
                    this.loadingCicloEscolar = false
                }catch(error){
                    this.loadingCicloEscolar = false
                    console.log(error)
                }
            }
        },
        async getGrupo() {
            this.grupo = []
            if(this.cicloEscolar){
                try {
                    this.loadingGrupo = true
                    let params = {
                        "ciclo_escolar_id": this.cicloEscolar
                    }
                    const { data: response } = await reportes.getGrupo(this.institucion, params)
                    this.grupos = response
                    this.gruposId = (new Date()).getTime()
                    this.loadingGrupo = false
                }
                catch(error){
                    this.loadingGrupo = false
                    console.log(error)
                }
            }
        },
        async getCodigoDetallePagos() {
            this.codigoDetalle = []
            if(this.cicloEscolar){
                try {
                    this.loadingCodigo = true
                    const { data: response } = await reportes.getCodigoDetallePagos()
                    this.codigosDetalle = this.getArrayCodigo(response)
                    this.codigosDetalleId = (new Date()).getTime()
                    this.loadingCodigo = false
                }
                catch(error){
                    this.loadingCodigo = false
                    console.log(error)
                }
            }
        },
        getArrayCodigo(info){
            const datos = Object.values(info)
            return datos
        },
        sanityForm () {
            this.errorFields = []
            if (!this.grupo) {
                this.errorFields.push('grupo')
            }
            if (!this.institucion) {
                this.errorFields.push('institucion')
            }
            if (!this.cicloEscolar) {
                this.errorFields.push('cicloEscolar')
            }
            if (!this.estatus) {
                this.errorFields.push('estatus')
            }
            if (!this.errorFields.length){
                return true
            } else {
                return null
            }
        },
        async getBecasAplicadas() {
            if(this.sanityForm()){
                const loading = this.$vs.loading()
                this.users = []
                this.estadisticas_becas = {}
                try {
                    const params ={
                        "institucion_id": this.institucion,
                        "ciclo_escolar_id": this.cicloEscolar,
                        "type_response": "json",
                        "estatus": this.estatus == 'activo' ? 'activo' : 'inactivo',
                    }

                    if(this.grupo[0] == ''){
                        const eliminarGrupo = this.grupo.shift()
                        params.grupos_ids = this.grupo
                    }else{
                        params.grupos_ids = this.grupo
                    }

                    // if(this.codigoDetalle[0] == ''){
                    //     const eliminarCodigo = this.codigoDetalle.shift()
                    //     params.codigos_detalles_ids = this.codigoDetalle
                    // }else{
                    //     params.codigos_detalles_ids = this.codigoDetalle
                    // }
                    
                    const { data: response } = await reportes.getBecasAplicadas(params)
                    this.users = response.info
                    this.estadisticas_becas = response.movimientos
                    this.estatusFiltro = this.estatus
                    loading.close()
                }
                catch(error){
                    console.log(error)
                    loading.close()
                    
                }
            }
        },
        
        async getFileBecasAplicas(){
            this.loadingExcel = true
            const params ={
                "institucion_id": this.institucion,
                "ciclo_escolar_id": this.cicloEscolar,
                "type_response": "file",
                "estatus": this.estatus == 'activo' ? 'activo' : 'inactivo',
            }

            if(this.grupo[0] == ''){
                const eliminarGrupo = this.grupo.shift()
                params.grupos_ids = this.grupo
            }else{
                params.grupos_ids = this.grupo
            }

            // if(this.codigoDetalle[0] == ''){
            //     const eliminarCodigo = this.codigoDetalle.shift()
            //     params.codigos_detalles_ids = this.codigoDetalle
            // }else{
            //     params.codigos_detalles_ids = this.codigoDetalle
            // }
            setTimeout(() => {
                axios.post('/reportesMovimientos/getBecas', params, {
                    responseType: 'blob',
                    // responseType: 'arraybuffer',
                }).then(response => {
                    this.loadingExcel = false
                    if (response.data instanceof Blob) {
                        const downloadUrl = window.URL.createObjectURL(new Blob([response.data]));
                        const link = document.createElement('a');
                        link.href = downloadUrl;
                        var filename = "";
                        const disposition = response.headers['content-disposition'];
                        if (disposition && disposition.indexOf('attachment') !== -1) {
                            const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                            const matches = filenameRegex.exec(disposition);
                            if (matches != null && matches[1]) {
                                filename = matches[1].replace(/['"]/g, '');
                                link.setAttribute('download', filename)
                            }
                        }
                        document.body.appendChild(link);
                        link.click();
                        link.remove();
                    }else{
                        throw { message: 'formatError' }
                    }
                    this.$vs.notification({
                        progress: 'auto',
                        color: 'success',
                        position: 'bottom-right',
                        title: 'Éxito',
                        text: 'Descarga lista'
                    })
                    this.loadingExcel = false
                }).catch(e => {
                    this.loadingExcel = false
                    this.$vs.notification({
                        progress: 'auto',
                        color: 'danger',
                        position: 'bottom-right',
                        title: 'Ocurrió un problema inesperado'
                    })
                });
            }, 500);
        },
    },
    watch:{
        institucion(){
            this.cicloEscolar = ''
            this.grupo = []
            this.grupos = []
            this.codigoDetalle = []
            this.codigosDetalle = []
        },
        cicloEscolar(){
            this.getGrupo()
            // this.getCodigoDetallePagos()
        }
    }
}
</script>

<style lang="scss" scoped>
    .tache{
        position: absolute;
        cursor: pointer;
        top: 10px;
        @media only screen and (max-width: 768px) {
            left: calc(95% - 4em);
        }
        @media only screen and (min-width: 768px) {
            left: calc(98% - 4em);
        }

    }
</style>
